<template>
    <div :style="{'display':'flex'}">
            <audio-tool :style="{'padding-top':'6px'}"></audio-tool>
            <menu-tool :style="{'padding-top':'0px'}"></menu-tool>
            <el-button-group :style="{'display':'flex'}">
                <user-load-tool></user-load-tool>
                <tool-tool></tool-tool>
            </el-button-group>
            <memory-tool></memory-tool>
    </div>
</template>

<script>
    import AudioTool from "./AudioTool";
    import MenuTool from "./MenuTool";
    import UserLoadTool from "./UserLoadTool";
    import ToolTool from "./ToolTool";
    import MemoryTool from "./MemoryTool";
    export default {
        name: "WordToolButtonP",
        components:{
            AudioTool,
            MenuTool,
            UserLoadTool,
            ToolTool,
            MemoryTool,
        },
        data() {
            return {
                // newWordListNum:0,
                // drawer: false,
                // dialogFormVisible: false,
                // loginUser:{
                //     username: '',
                //     password:'',
                // },
                // value: '100',

            };
        },
        methods: {
            // handleCommand(command) {
            //     this.$store.dispatch('requireNewWord');
            //     this.$bus.$emit('newWordLoad');
            //     this.$store.commit('setShowModuleList','背词');
            //
            // },
            // login(ruleForm){
            //     // this.loginUser.username=ruleForm.userAccount;
            //     // this.loginUser.password=ruleForm.pass;
            //     console.log(ruleForm.userAccount);
            //     this.$store.dispatch('requireWordLogin',ruleForm).then(res=>{
            //         this.$message({
            //              message: '恭喜' + res +',你已成功登陆',
            //              type: 'success'
            //          });
            //          this.dialogFormVisible=false;
            //     });
            //
            // },

            // getCookie(name) {
            //     var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            //     if (arr = document.cookie.match(reg))
            //         return unescape(arr[2]);
            //     else
            //         return null;
            // }
        },

    }
</script>

<style scoped>

</style>
